module.exports = __webpack_public_path__ + "static/img/knows.0bf400ec.png";